export type PermissionNames =
    "View Users" | "Manage Users" | "Add Users" | "Edit Users" | "Delete Users" | "List Users" | "Approve Users" | "User Usage Settings" | "Export Users" | "Impersonate User" |
    "View Roles" | "Manage Roles" |
    "Manage Customers" | "Add Customers" | "Edit Customers" | "View Customers" | "Delete Customers" | "List Customers" | "Export Customers" |
    "Manage Delivery Address" | "Add DeliveryAddress" | "Edit DeliveryAddress" | "View DeliveryAddress" | "Delete DeliveryAddress" | "List DeliveryAddress" |
    "Manage Suppliers" | "Add Suppliers" | "Edit Suppliers" | "View Suppliers" | "Delete Suppliers" | "List Suppliers" |
    "Dashboard" | "Export" | "Electricity Overview" | "Add ElectricityContract" | "Edit ElectricityContract" | "View ElectricityContract" | "Delete ElectricityContract" | "List ElectricityContract" |
    "Add InjectionContract" | "Edit InjectionContract" | "View InjectionContract" | "Delete InjectionContract" | "List InjectionContract" |
    "Dashboard" | "Export" | "GAS Overview" | "Add GasContract" | "Edit GasContract" | "View GasContract" | "Delete GasContract" | "List GasContract" |
    "View Dashboard Count and Dates" | "Upload Documents" | "Manage Customers Mapping" | "View Customers Mapping" | "Edit Customers Mapping" |
    "Manage Users Mapping" | "View Users Mapping" | "Edit Users Mapping" | "OIL Overview" | "Export" | "Coal Overview" | "Export" |
    "CoTwo Overview" | "Export" | "GasTwo Overview" | "Export" |
    "Add GasTwo" | "Manage GasTwo" | "Edit GasTwo" |  "Delete GasTwo" |
    "Belpex Overview" | "Export" |
    "GasThree Overview" | "Export" | "Add GasThree" | "Manage GasThree" | "Edit GasThree" | "Delete GasThree";


export type PermissionValues =
    "users.view" | "users.manage" | "users.add" | "users.edit" | "users.delete" | "users.list" | "users.approve" | "users.usagesettings" | "users.export" | "users.impersonateuser" |
    "roles.view" | "roles.manage" |
    "customers.manage" | "customers.add" | "customers.edit" | "customers.view" | "customers.delete" | "customers.list" | "customers.export" |
    "deliveryAddress.manage" | "deliveryAddress.add" | "deliveryAddress.edit" | "deliveryAddress.view" | "deliveryAddress.delete" | "deliveryAddress.list" |
    "suppliers.manage" | "suppliers.add" | "suppliers.edit" | "suppliers.view" | "suppliers.delete" | "suppliers.list" |
    "electricity.dashboard" | "electricity.export" | "electricity.overview" | "electricity.add" | "electricity.edit" | "electricity.view" | "electricity.delete" | "electricity.list" |
    "injection.add" | "injection.edit" | "injection.view" | "injection.delete" | "injection.list" |
    "gas.dashboard" | "gas.export" | "gas.overview" | "gas.add" | "gas.edit" | "gas.view" | "gas.delete" | "gas.list" |
    "dashboard.dashboard" | "dashboard.upload" | "customersMapping.manage" | "customersMapping.view" | "customersMapping.edit" |
    "usersMapping.manage" | "usersMapping.view" | "usersMapping.edit" | "oil.overview" | "oil.export" | "coal.overview" | "coal.export" |
    "cotwo.overview" | "cotwo.export" | "gastwo.overview" | "gastwo.export" | "gastwo.add" | "gastwo.manage" | "gastwo.edit" | "gastwo.delete" |
    "belpex.overview" | "belpex.export" |
    "gasthree.overview" | "gasthree.export" | "gasthree.add" | "gasthree.manage" | "gasthree.edit" | "gasthree.delete";




export class Permission {

    public static readonly viewUsersPermission: PermissionValues = "users.view";
    public static readonly manageUsersPermission: PermissionValues = "users.manage";
    public static readonly addUsersPermission: PermissionValues = "users.add";
    public static readonly editUsersPermission: PermissionValues = "users.edit";
    public static readonly deleteUsersPermission: PermissionValues = "users.delete";
    public static readonly listUsersPermission: PermissionValues = "users.list";
    public static readonly approveUsersPermission: PermissionValues = "users.approve";
    public static readonly manageUsersUsageSettings: PermissionValues = "users.usagesettings";
    public static readonly impersonateUserPermission: PermissionValues = "users.impersonateuser";
    public static readonly exportUsersPermission: PermissionValues = "users.export";



    public static readonly viewRolesPermission: PermissionValues = "roles.view";
    public static readonly manageRolesPermission: PermissionValues = "roles.manage";

    public static readonly manageCustomersPermission: PermissionValues = "customers.manage";
    public static readonly addCustomersPermission: PermissionValues = "customers.add";
    public static readonly editCustomersPermission: PermissionValues = "customers.edit";
    public static readonly deleteCustomersPermission: PermissionValues = "customers.delete";
    public static readonly viewCustomersPermission: PermissionValues = "customers.view";
    public static readonly listCustomersPermission: PermissionValues = "customers.list";
    public static readonly exportCustomersPermission: PermissionValues = "customers.export";

    public static readonly manageCustomersMappingPermission: PermissionValues = "customersMapping.manage";
    public static readonly viewCustomersMappingPermission: PermissionValues = "customersMapping.view";
    public static readonly editCustomersMappingPermission: PermissionValues = "customersMapping.edit";

    public static readonly manageUsersMappingPermission: PermissionValues = "usersMapping.manage";
    public static readonly viewUsersMappingPermission: PermissionValues = "usersMapping.view";
    public static readonly editUsersMappingPermission: PermissionValues = "usersMapping.edit";

    public static readonly manageDeliveryAddressPermission: PermissionValues = "deliveryAddress.manage";
    public static readonly addDeliveryAddressPermission: PermissionValues = "deliveryAddress.add";
    public static readonly editDeliveryAddressPermission: PermissionValues = "deliveryAddress.edit";
    public static readonly deleteDeliveryAddressPermission: PermissionValues = "deliveryAddress.delete";
    public static readonly viewDeliveryAddressPermission: PermissionValues = "deliveryAddress.view";
    public static readonly listDeliveryAddressPermission: PermissionValues = "deliveryAddress.list";

    public static readonly manageSuppliersPermission: PermissionValues = "suppliers.manage";
    public static readonly addSuppliersPermission: PermissionValues = "suppliers.add";
    public static readonly editSuppliersPermission: PermissionValues = "suppliers.edit";
    public static readonly deleteSuppliersPermission: PermissionValues = "suppliers.delete";
    public static readonly viewSuppliersPermission: PermissionValues = "suppliers.view";
    public static readonly listSuppliersPermission: PermissionValues = "suppliers.list";


    public static readonly manageElectricityDashboardPermission: PermissionValues = "electricity.dashboard";
    public static readonly electricityExportPermission: PermissionValues = "electricity.export";
    public static readonly electricityOverviewPermission: PermissionValues = "electricity.overview";
    public static readonly electricityContractAddPermission: PermissionValues = "electricity.add";
    public static readonly electricityContractEditPermission: PermissionValues = "electricity.edit";
    public static readonly electricityContractViewPermission: PermissionValues = "electricity.view";
    public static readonly electricityContractDeletePermission: PermissionValues = "electricity.delete";
    public static readonly electricityContractListPermission: PermissionValues = "electricity.list";

    public static readonly injectionContractAddPermission: PermissionValues = "injection.add";
    public static readonly injectionContractEditPermission: PermissionValues = "injection.edit";
    public static readonly injectionContractViewPermission: PermissionValues = "injection.view";
    public static readonly injectionContractDeletePermission: PermissionValues = "injection.delete";
    public static readonly injectionContractListPermission: PermissionValues = "injection.list";


    public static readonly manageGasDashboardPermission: PermissionValues = "gas.dashboard";
    public static readonly gasExportPermission: PermissionValues = "gas.export";
    public static readonly gasOverviewPermission: PermissionValues = "gas.overview";
    public static readonly gasContractAddPermission: PermissionValues = "gas.add";
    public static readonly gasContractEditPermission: PermissionValues = "gas.edit";
    public static readonly gasContractViewPermission: PermissionValues = "gas.view";
    public static readonly gasContractDeletePermission: PermissionValues = "gas.delete";
    public static readonly gasContractListPermission: PermissionValues = "gas.list";

    public static readonly oilOverviewPermission: PermissionValues = "oil.overview";
    public static readonly oilExportPermission: PermissionValues = "oil.export";

    public static readonly CoalOverviewPermission: PermissionValues = "coal.overview";
    public static readonly CoalExportPermission: PermissionValues = "coal.export";

    public static readonly CoTwoOverviewPermission: PermissionValues = "cotwo.overview";
    public static readonly CoTwoExportPermission: PermissionValues = "cotwo.export";

    public static readonly GasTwoOverviewPermission: PermissionValues = "gastwo.overview";
    public static readonly addGasTwoPermission: PermissionValues = "gastwo.add";
    public static readonly GasTwoExportPermission: PermissionValues = "gastwo.export";
    public static readonly manageGasTwoPermission: PermissionValues = "gastwo.manage";
    public static readonly editGasTwoPermission: PermissionValues = "gastwo.edit";
    public static readonly deleteGasTwoPermission: PermissionValues = "gastwo.delete";

    public static readonly manageDashboardPermission: PermissionValues = "dashboard.dashboard";
    public static readonly gasImportPermission: PermissionValues = "dashboard.upload";

    public static readonly belpexExportPermission: PermissionValues = "belpex.export";
    public static readonly belpexOverviewPermission: PermissionValues = "belpex.overview";

    public static readonly GasThreeOverviewPermission: PermissionValues = "gasthree.overview";
    public static readonly addGasThreePermission: PermissionValues = "gasthree.add";
    public static readonly GasThreeExportPermission: PermissionValues = "gasthree.export";
    public static readonly manageGasThreePermission: PermissionValues = "gasthree.manage";
    public static readonly editGasThreePermission: PermissionValues = "gasthree.edit";
    public static readonly deleteGasThreePermission: PermissionValues = "gasthree.delete";

    constructor(name?: PermissionNames, value?: PermissionValues, groupName?: string, description?: string) {
        this.Name = name;
        this.Value = value;
        this.GroupName = groupName;
        this.Description = description;
    }

    public Name: PermissionNames;
    public Value: PermissionValues;
    public GroupName: string;
    public Description: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/permission.model.ts